import React from 'react';
import "./safeInformation.scss";

//images
import imgsafeInformation from "../../../assets/connectors/safeInformation.png";
import { useTranslation } from 'react-i18next';

const SafeInformation = () => {
    const {t} = useTranslation()

    return (
        <div className="container-safeInformation">
            <div className="img-safeInformationDesk">
                <img src={imgsafeInformation} alt="" />
            </div>
            <div className="texts-safeInformation">
                <h1>{t("connectors.safe_information.title")}</h1>
                <p>{t("connectors.safe_information.section_text")}</p>
                <div className="img-safeInformationMobile">
                    <img src={imgsafeInformation} alt="" />
                </div>
                {/* <button id="btn-safeInformation">Saiba mais</button> */}
            </div>
        </div>
    )
}

export default SafeInformation;